/**
 * When fetching data using `useAsync`, we need to do a few things to make
 * sure the page view is tracked correctly.
 * On SSR, the data will be there onMounted so we can just track using a normal onMounted. However
 * on CSR (clicking through a link) the data will not always exist when onMounted is called so
 * we have to watch the data and track when it is available.
 */

import { Ref, onMounted, watch } from '@nuxtjs/composition-api';

export const useTrackPageView = <T>(pageItem: Ref<T | null>, trackFn: (item: T) => void): void => {
  onMounted(() => {
    if (pageItem.value) {
      trackFn(pageItem.value);
    } else {
      const unwatch = watch(
        pageItem,
        (newItem, oldItem) => {
          if (!oldItem && newItem) {
            trackFn(newItem);
            unwatch();
          }
        },
        { immediate: true }
      );
    }
  });
};
